import {AlertIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import sidebarListStyles from '../SidebarActionList.module.css'

export function ActivityError() {
  return (
    <span className={clsx(sidebarListStyles.emptyState, 'd-flex flex-items-center gap-2')}>
      <AlertIcon className="color-fg-danger" />
      Unable to load activity
    </span>
  )
}
